import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { adminInstance } from "../../config/axios";
import { useLocation } from "react-router-dom";
import Loader from "../loader/loader";
import AddGiveawayForm from "./addGiveawayForm";
const AddGiveaway = () => {
  const initialObj = {
    title: "",
    image: null,
    prize: "",
    endTime: "",
    winnerCount: "",
  };

  const [payload, setPayload] = useState(initialObj);
  const [loading, setLoading] = useState(false);
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let giveawayId = query.get("id");
  const formatForDateTimeLocal = (date) => {
    if (!date) return "";
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 16);
  };

  const getSingleGiveawayData = async (id) => {
    try {
      setLoading(true);

      const response = await adminInstance().get(
        `/api/admin/getGiveawayById/${id}`,
      );

      const { code, giveAway } = response.data;

      if (code === 200) {
        setPayload({
          ...giveAway,
          endTime: formatForDateTimeLocal(giveAway.endTime),
        });

        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (giveawayId) {
      getSingleGiveawayData(giveawayId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [giveawayId]);

  return (
    <Fragment>
      <Breadcrumb title="Add Giveaway" parent="Giveaways" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <h5>Add Giveaway</h5>
              </CardHeader>
              <CardBody>
                {giveawayId ? (
                  !loading ? (
                    payload?._id && (
                      <AddGiveawayForm
                        payload={payload}
                        setPayload={setPayload}
                      />
                    )
                  ) : (
                    <Loader />
                  )
                ) : (
                  <AddGiveawayForm payload={payload} setPayload={setPayload} />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AddGiveaway;
